import { useEffect } from "react";
import Lenis from "lenis";
import { useContent } from "@/hooks/useContent";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import About from "@/components/site/About";
import Projects from "@/components/site/Projects";
import TypeHouse from "@/components/site/TypeHouse";
import Advantages from "@/components/site/Advantages";
import Facilities from "@/components/site/Facilities";
import LocationSection from "@/components/site/LocationSection";
import GallerySection from "@/components/site/GallerySection";
import Pricing from "@/components/site/Pricing";
import KprCalculator from "@/components/site/KprCalculator";
import FaqSection from "@/components/site/FaqSection";
import Testimonials from "@/components/site/Testimonials";
import LeadForm from "@/components/site/LeadForm";
import CtaBanner from "@/components/site/CtaBanner";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import AudioPlayer from "@/components/site/AudioPlayer";

export default function LandingPage() {
  const { content, loading, error } = useContent();

  useEffect(() => {
    document.title = "Sakofa Properti — Perumahan Type 36 Cluster Pontianak | PT. Cahaya Sakofa Mulia";
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.1 });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white" data-testid="landing-loading">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-brand border-t-transparent" />
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white px-6" data-testid="landing-error">
        <p className="text-center text-slate-600">Konten sedang tidak dapat dimuat. Silakan muat ulang halaman.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Navbar content={content} />
      <main>
        <Hero content={content} />
        <EditorialMarquee />
        <About content={content} />
        <Projects content={content} />
        <TypeHouse content={content} />
        <Advantages content={content} />
        <Facilities content={content} />
        <LocationSection content={content} />
        <GallerySection content={content} />
        <Pricing content={content} />
        <KprCalculator />
        <FaqSection content={content} />
        <Testimonials content={content} />
        <LeadForm content={content} />
        <CtaBanner content={content} />
      </main>
      <Footer content={content} />
      <WhatsAppFloat content={content} />
      <AudioPlayer />
    </div>
  );
}
